export default "__VITE_ASSET__lAXWWSOI__"